module.exports = __webpack_public_path__ + "img/home-page-girl-hear-mobile-min.68550e15.jpg";